import { ChordHistoryOptions } from "../models/ChordHistoryOptions.model";
import { KeySelectionOptions } from "../models/KeySelectionOptions.model";

function createGuid(): string {
  try {
    return crypto.randomUUID();
  } catch {
    return "uuid-gen-failed";
  }
}

const VISITOR_ID = "vid";
const HIST_SETTINGS = "hist_settings_v1";
const KEY_SETTINGS = "key_settings_v1";

export function saveVisitorId() {
  try {
    window.localStorage.setItem(VISITOR_ID, createGuid());
  } catch (_e) {}
}
export function getVisitorId(): string | null {
  try {
    return window.localStorage.getItem(VISITOR_ID);
  } catch (_e) {
    return null;
  }
}

export function saveChordHistorySettings(settings: ChordHistoryOptions) {
  try {
    window.localStorage.setItem(HIST_SETTINGS, JSON.stringify(settings));
  } catch (_e) {}
}
export function saveKeySelectionSettings(settings: KeySelectionOptions) {
  try {
    window.localStorage.setItem(KEY_SETTINGS, JSON.stringify(settings));
  } catch (_e) {}
}
export function loadChordHistorySettings(): Partial<ChordHistoryOptions> | null {
  try {
    const settings = window.localStorage.getItem(HIST_SETTINGS);
    if (settings) {
      return JSON.parse(settings) as Partial<ChordHistoryOptions>;
    }
  } catch (_e) {}
  return null;
}
export function loadKeySelectionSettings(): Partial<KeySelectionOptions> | null {
  try {
    const settings = window.localStorage.getItem(KEY_SETTINGS);
    if (settings) {
      return JSON.parse(settings) as Partial<KeySelectionOptions>;
    }
  } catch (_e) {}
  return null;
}

export function loadSavedSettings() {}
